import SendAnnouncement from 'pages/Annoucement/SendAnnouncement';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { useEffect } from 'react';
import { Alert, Typography } from '@mui/material';
import { fetchAnnouncementDetails } from 'redux/slices/announcements/announcementDetailSlice';
import { selectSelectedParishId } from 'redux/selectors/parishContext';
import MuiLoader from 'components/Common/Loader';
import CardWrapper from 'components/Common/CardWrapper';

/**
 * Resend / edit surface. Nest announcement GET does not return original groupIds,
 * so we must not silently default groupId to null (would allow sending to a wrong audience).
 * Block send until product/API can restore the original audience.
 */
const EditAnnouncementContainer = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const parishId = useSelector(selectSelectedParishId);
    const announcement = useSelector((state: RootState) => state.announcement.announcementDetails);
    const { details, loading } = announcement || {};

    useEffect(() => {
        if (!parishId || !id) return;
        if (details?.id !== id) {
            dispatch(fetchAnnouncementDetails({ parishId, id }));
        }
    }, [details?.id, id, dispatch, parishId]);

    if (loading || !details || details.id !== id) {
        return (
            <CardWrapper>
                <MuiLoader absolute loading />
            </CardWrapper>
        );
    }

    return (
        <CardWrapper>
            <Alert severity="warning" sx={{ mb: 2 }}>
                Resend is blocked: the original announcement audience is not available from the API, so this portal will not send to a
                different group by mistake.
            </Alert>
            <Typography sx={{ mb: 2, color: 'text.secondary', fontSize: 14 }}>
                You can review the title and message below. Create a new announcement if you need to notify a group again.
            </Typography>
            <SendAnnouncement
                key={details.id}
                defaultValues={{
                    title: details.title || '',
                    message: details.message || '',
                    groupId: null,
                }}
                resendBlocked
            />
        </CardWrapper>
    );
};

export default EditAnnouncementContainer;
